export default {
    'searchTotalTitle': [
        {
            'name': '合单码是否为空',
            'value': 'emptyConsolidationOrderNo',
            'type': 'select',
            'optionNum': 'COMBINE_CODE',
            'options': [],
            'chooseKey': 'emptyConsolidationOrderNo',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '线路',
            'value': 'lineName',
            'type': 'advance',
            'multiple': true,
            'border': true,
            'dialogWidth': '800px',
            'multipleTableColumn': {
                'prop': 'lineMergeName', 'value': '线路名称'
            },
            'advanceConfig': [
                { 'prop': 'lineMergeName', 'value': '线路名称' },
                { 'prop': 'lineMergeId', 'value': '线路编码' }
            ],
            'tableConfig': [
                { 'prop': 'lineMergeName', 'value': '线路名称' },
                { 'prop': 'lineMergeId', 'value': '线路编码' }
            ],
            'method': 'post',
            'prefix': '/api-opms',
            'advanceUrl': '/opms/searchMergeLine',
            'advanceNotSearch': true,
            'paramType': true,
            'cbParams': ['lineMergeName#lineName', 'lineMergeId#chooseValueCode'],
            'chooseKey': 'lineCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '运输单号',
            'value': 't.taskNo',
            'type': 'input',
            'chooseKey': 't.taskNo',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '方量',
            'type': 'inputRange',
            'value': 'totalVolume',
            'range': ['chooseValueMin', 'chooseValueMax'],
            'chooseValueMin': '',
            'chooseValueMax': '',
            'chooseKey': 'totalVolume',
            'detailType': '2',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '要求发车时间',
            'value': 'requireDepartTime',
            'type': 'time',
            'detailType': '2',
            'chooseKey': 'requireDepartTime',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '要求抵达时间',
            'value': 'requireArriveTime',
            'type': 'time',
            'chooseKey': 'requireArriveTime',
            'detailType': '2',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '客户',
            'value': 'cpName',
            'type': 'advance',
            'multiple': true,
            'border': true,
            'dialogWidth': '800px',
            'multipleTableColumn': {
                'prop': 'ebcuNameCn', 'value': '客户名称'
            },
            'advanceConfig': [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            'advanceUrl': '/ebCustomer/searchByEbCustomer',
            'cbParams': ['pmCode#chooseValueCode', 'ebcuNameCn#cpName'],
            'chooseKey': 'customerCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '服务平台',
            'value': 'siteName',
            'type': 'advance',
            'multiple': true,
            'border': true,
            'dialogWidth': '800px',
            'multipleTableColumn': {
                'prop': 'escoCompanyNameCn', 'value': '服务平台名称'
            },
            'advanceConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'tableConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'advanceUrl': '/searchPlatform',
            'cbParams': ['escoCompanyNo#chooseValueCode', 'escoCompanyNameCn#siteName'],
            'chooseKey': 'siteCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '订单类型',
            'value': 'orderType',
            'type': 'select',
            'multiple': true,
            'filterable': true,
            'optionNum': 'ORDER_TYPE',
            'options': [],
            'chooseKey': 'orderType',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '集拼单号',
            'value': 'consolidationOrderNo',
            'type': 'input',
            'chooseKey': 'consolidationOrderNo',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '仓库',
            'value': 'whName',
            'multiple': true,
            'border': true,
            'dialogWidth': '800px',
            'multipleTableColumn': {
                'prop': 'cdwhName', 'value': '仓库名称'
            },
            'advanceConfig': [
                { 'prop': 'cdwhName', 'value': '仓库名称' },
                { 'prop': 'whCode', 'value': '仓库编码' }
            ],
            'tableConfig': [
                { 'prop': 'cdwhName', 'value': '仓库名称' },
                { 'prop': 'whCode', 'value': '仓库编码' }
            ],
            'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
            'cbParams': [
                'whCode#chooseValueCode', 'cdwhName#whName'
            ],
            'type': 'advance',
            'chooseKey': 'whCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '物流订单号',
            'value': 'orderNo',
            'type': 'input',
            'chooseKey': 'orderNo',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '目的地省',
            'value': 'receiverProvinceName',
            'type': 'advance',
            'multiple': true,
            'border': true,
            'dialogWidth': '800px',
            'multipleTableColumn': {
                'prop': 'ebplNameCn', 'value': '目的地省名称'
            },
            'advanceConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地省名称' },
                { 'prop': 'ebplCode', 'value': '目的地省编码' }
            ],
            'tableConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地省名称' },
                { 'prop': 'ebplCode', 'value': '目的地省编码' }
            ],
            'cbParams': [
                'ebplCode#chooseValueCode', 'ebplNameCn#receiverProvinceName'
            ],
            'advanceUrl': '/searchEbPlacePage?ebplType=PLACE_PROVINCE&ebplParentPmCode=100000',
            'chooseKey': 'receiverProvinceCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '目的地市',
            'value': 'receiverCityName',
            'type': 'advance',
            'multiple': true,
            'border': true,
            'dialogWidth': '800px',
            'multipleTableColumn': {
                'prop': 'ebplNameCn', 'value': '目的地市名称'
            },
            'advanceConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地市名称' },
                { 'prop': 'ebplCode', 'value': '目的地市编码' }
            ],
            'tableConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地省名称' },
                { 'prop': 'ebplCode', 'value': '目的地市编码' }
            ],
            'cbParams': [
                'ebplCode#chooseValueCode', 'ebplNameCn#receiverCityName'
            ],
            'advanceUrl': '/searchEbPlacePage?ebplType=PLACE_CITY',
            'chooseKey': 'receiverCityCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '目的地区',
            'value': 'receiverDistrictName',
            'type': 'advance',
            'multiple': true,
            'border': true,
            'dialogWidth': '800px',
            'multipleTableColumn': {
                'prop': 'ebplNameCn', 'value': '目的地区名称'
            },
            'advanceConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地区名称' },
                { 'prop': 'ebplCode', 'value': '目的地区编码' }
            ],
            'tableConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地区名称' },
                { 'prop': 'ebplCode', 'value': '目的地区编码' }
            ],
            'cbParams': [
                'ebplCode#chooseValueCode', 'ebplNameCn#receiverDistrictName'
            ],
            'advanceUrl': '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
            'chooseKey': 'receiverDistrictCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '目的地乡镇',
            'value': 'receiverTownName',
            'type': 'advance',
            'multiple': true,
            'border': true,
            'dialogWidth': '800px',
            'multipleTableColumn': {
                'prop': 'ebplNameCn', 'value': '目的地乡镇名称'
            },
            'advanceConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '目的地乡镇编码' }
            ],
            'tableConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '目的地乡镇编码' }
            ],
            'cbParams': [
                'ebplCode#chooseValueCode', 'ebplNameCn#receiverTownName'
            ],
            'advanceUrl': '/searchEbPlacePage?ebplType=PLACE_STREET',
            'chooseKey': 'receiverTownCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '来源系统',
            'value': 'sourceSystemLists',
            'type': 'select',
            'multiple': true,
            'filterable': true,
            'optionNum': 'SOURCE_SYSTEM',
            'options': [],
            'chooseKey': 'sourceSystemLists',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '原始订单号',
            'value': 'originOrderNo',
            'type': 'input',
            'chooseKey': 'originOrderNo',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '源发车单号',
            'value': 'sourceDispatch',
            'type': 'input',
            'chooseKey': 'sourceDispatch',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '是否分拨订单',
            'value': 'distributionFlag',
            'type': 'select',
            'options': [{ 'value': 'Y', 'label': '是' }, { 'value': 'N', 'label': '否' }],
            'chooseKey': 'distributionFlag',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '是否继续分拨',
            'value': 'distributionContinueFlag',
            'type': 'select',
            'options': [{ 'value': 'Y', 'label': '是' }, { 'value': 'N', 'label': '否' }],
            'chooseKey': 'distributionContinueFlag',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '是否模糊订单',
            'value': 'planOrderFlag',
            'type': 'select',
            'options': [{ 'value': '1', 'label': '是' }, { 'value': '0', 'label': '否' }],
            'chooseKey': 'planOrderFlag',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '项目分类',
            'value': 'projectClassify',
            'type': 'select',
            'multiple': true,
            'filterable': true,
            'optionNum': 'PROJECT_CLASSIFY',
            'options': [],
            'chooseKey': 'projectClassify',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '库区',
            'value': 'zoneName',
            'type': 'input',
            'chooseKey': 'zoneName',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '网点编码',
            'value': 'networkCode',
            'type': 'input',
            'chooseKey': 'networkCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '网点名称',
            'value': 'networkName',
            'type': 'input',
            'chooseKey': 'networkName',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '预配载',
            'value': 'cnDispatch',
            'type': 'select',
            'optionNum': 'YES_OR_NO',
            'options': [],
            'chooseKey': 'cnDispatch',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        // {
        //     'name': '收货仓编码',
        //     'value': 'upperReceiverCode',
        //     'type': 'input',
        //     'chooseKey': 'upperReceiverCode',
        //     'detailType': '0',
        //     'chooseValueCode': '',
        //     'chooseValueName': ''
        // },
        {
            'name': '收货仓名称',
            'value': 'upperReceiverName',
            'type': 'input',
            'chooseKey': 'upperReceiverName',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '任务类型',
            'value': 'taskType',
            'type': 'select',
            'multiple': true,
            'filterable': true,
            'optionNum': 'TASK_TYPE',
            'options': [],
            'chooseKey': 'taskType',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '业务模式',
            'value': 'businessMode',
            'type': 'select',
            'optionNum': 'BUSINESS_MODE',
            'options': [],
            'chooseKey': 'businessMode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '是否下发',
            'value': 'carrierVisibleFlag',
            'type': 'select',
            'options': [{ 'value': 'Y', 'label': '是' }, { 'value': 'N', 'label': '否' }],
            'chooseKey': 'carrierVisibleFlag',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '是否预约',
            'value': 'appointTimeFlag',
            'type': 'select',
            'options': [{ 'value': '1', 'label': '是' }, { 'value': '0', 'label': '否' }],
            'chooseKey': 'appointTimeFlag',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '是否精准配送',
            'value': 'isJzp',
            'type': 'select',
            'options': [{ 'value': 'Y', 'label': '是' }, { 'value': 'N', 'label': '否' }],
            'chooseKey': 'isJzp',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '上游集拼单号',
            'value': 'consolidationOrderNos',
            'type': 'input',
            'chooseKey': 'consolidationOrderNos',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': 'WMS状态',
            'value': 'wmsStatus',
            'type': 'select',
            'optionNum': 'WMS_STATUS',
            'options': [],
            'chooseKey': 'wmsStatus',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '是否仓配分离',
            'value': 'logisticMode',
            'type': 'select',
            'options': [{ 'value': 'WT', 'label': '是' }, { 'value': 'TW', 'label': '否' }],
            'chooseKey': 'logisticMode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '商超标识',
            'value': 'scPosFlag',
            'type': 'select',
            'options': [{ 'value': '1', 'label': '是' }, { 'value': '0', 'label': '否' }],
            'chooseKey': 'scPosFlag',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '配送方式',
            'value': 'deliveryType',
            'type': 'select',
            'optionNum': 'DELIVERY_TYPE',
            'options': [],
            'multiple': true,
            'filterable': true,
            'chooseKey': 'deliveryType',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '收货单位',
            'value': 'upperReceiverName',
            'multiple': true,
            'border': true,
            'dialogWidth': '1100px',
            'multipleTableConfig': [
                { 'prop': 'ebspNameCn', 'value': '单位名称' },
                { 'prop': 'ebspShipperNo', 'value': '单位编码' }
            ],
            'multipleTableColumn': {
                'prop': 'ebspNameCn', 'value': '单位名称'
            },
            'advanceConfig': [
                { 'prop': 'ebspNameCn', 'value': '单位名称' },
                { 'prop': 'ebspShipperNo', 'value': '单位编码' }
            ],
            'tableConfig': [
                { 'prop': 'ebspNameCn', 'value': '单位名称', 'width': '200px' },
                { 'prop': 'ebspShipperNo', 'value': '单位编码', 'width': '130px' },
                { 'prop': 'ebspUpstreamDetailAddress', 'value': '地址详情' }
            ],
            'advanceUrl': '/ebShippers',
            'cbParams': ['ebspShipperNo#chooseValueCode', 'ebspNameCn#upperReceiverName'],
            'type': 'advance',
            'chooseKey': 'upperReceiverCode',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        },
        {
            'name': '上撤样',
            'value': 'specimenType',
            'type': 'select',
            'filterable': true,
            'optionNum': 'UPSTREAM_SPECIMEN_TYPE',
            'options': [],
            'chooseKey': 'specimenType',
            'detailType': '0',
            'chooseValueCode': '',
            'chooseValueName': ''
        }
    ]
};
